import AuthenticationRepository from './AuthenticationRepository.js'

/**
 * @implements Repository
 * Cookie implementation
 */
export default class CookieAuthenticationRepository extends AuthenticationRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {JsCookie} deps.cookieManager
   * @param {String} deps.cookieName
   */
  constructor({cookieManager, config}) {
    super()

    this._cookieManager = cookieManager
    this._config = config
    this._cookieName = this._config.get('login').LOGIN_COOKIE_NAME
    this._legacyCookieName = this._config.get('login').LEGACY_LOGIN_COOKIE_NAME
    this._LOGIN_COOKIE_EXPIRATION_TIME_IN_DAYS = this._config.get('login').LOGIN_COOKIE_EXPIRATION_TIME_IN_DAYS
    this._clearValue = ''
    this._expiredCookieValue = -1
    this._SECURE_COOKIES = this._config.get('SECURE_COOKIES')
  }

  /**
   * @param {Object} params
   * @param {SessionAuthenticationValueObject} params.sessionAuthenticationValueObject
   * @return {Promise<void>}
   */
  setUserData({sessionAuthenticationValueObject}) {
    const userData = sessionAuthenticationValueObject.getUserData()
    this._cookieManager.set(this._cookieName, userData.toJSON(), {
      expires: this._LOGIN_COOKIE_EXPIRATION_TIME_IN_DAYS,
      secure: this._SECURE_COOKIES
    })

    return Promise.resolve({userData})
  }

  /**
   * @return {Promise<void>}
   */
  clearUserData() {
    this._cookieManager.set(this._cookieName, this._clearValue, {
      expires: this._expiredCookieValue
    })

    this._legacyCookieName &&
      this._cookieManager.set(this._legacyCookieName, this._clearValue, {
        expires: this._expiredCookieValue
      })

    return Promise.resolve()
  }
}
